<template>
  <b-row>
    <b-col cols="12">
      <b-card>
        <b-card-text class="ml-3">
          <h1>Welcome to Oceanbolt Data Platform</h1>
          <p>
            On this platform, you will find a range of different dry
            bulk/commodity related data, such as tradeflows:
          </p>
          <ul>
            <li>
              <router-link :to="{ name: 'Tradeflows' }">
                Global Aggregated Trade Flows
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'Port Flows' }">
                Port Level Trade Flows
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'Live Map' }">
                Live Vessel Map
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'Zone Map' }">
                Tonnage Supply Zone Maps
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'Congestion (New)' }">
                Congestion Analytics and Timeseries
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'Vessel Details' }">
                Vessel Level Details and Port Calls
              </router-link>
            </li>
          </ul>
          <p>
            In addition to the browser based dashboard, all the data is also
            available via the following tools:
          </p>
          <ul>
            <li>
              <a href="https://wiki.oceanbolt.com/excel_addin">
                Oceanbolt Excel Addin
              </a>
            </li>
            <li>
              <a href="https://python-sdk.oceanbolt.com">
                Oceanbolt Python SDK
              </a>
            </li>
          </ul>
          <h2>
            Beta Access to New Application
          </h2>
          <p>
            We are rebuilding and relaunching the entire Oceanbolt Web Application. The new application will be faster and slicker, but most importantly focused on delivering better user experience. <br>
            Currently, only a subset of the existing features have been implemented, but more will follow in coming weeks. <br>
            The beta version of the new application can be previewed at the following link:
          </p>
          <ul>
            <li>
              <a href="https://beta.oceanbolt.com">
                Oceanbolt Beta Application
              </a>
            </li>
          </ul>
        </b-card-text>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "home",

  data() {
    return {
      auth: {
        apiToken: null,
        user: {},
        admin: false,
        products: []
      },
      rawScreenshot: null,
      searchClient: null
    };
  },
  async mounted() {
    await this.setSearchClient();
    await this.getUserData();
    window.analytics.page("OpenedHome");
  },
  methods: {
    ...mapActions("api", ["getSearchClient", "getUser", "getToken", "logout"]),
    login() {},
    // Log the user out
    async logoutHandler() {
      await this.logout();
    },
    async getUserData() {
      this.auth.apiToken = await this.getToken();
      this.auth.user = await this.getUser();
    },
    async setSearchClient() {
      this.searchClient = await this.getSearchClient();
    }
  }
};
</script>

<style scoped></style>
